/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const totalStyle = {
  textAlign: "center",
  background: "#ddeff3",
  fontWeight: "bold",
  textAlign: "right",
  paddingRight: 20,
};

const titleStyle = {
  textAlign: "right",
  paddingRight: 20,
  background: "#ddeff3",
  fontWeight: "bold",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = [
  {
    id: uuidV4(),
    index: "1",
    spendId: 15,
    valueA: 0,
    valueB: 0,
    valueC: 0,
    valueD: 0,
    valueD2: 0,
    valueE: 0,
    valueG: 0,
    valueH: 0,
    valueI: 0,
    title: "Hoạt động đại lý xổ số",
  },
  {
    id: uuidV4(),
    index: "1",
    spendId: 16,
    valueA: 0,
    valueB: 0,
    valueC: 0,
    valueD: 0,
    valueD2: 0,
    valueE: 0,
    valueG: 0,
    valueH: 0,
    valueI: 0,
    title: "Hoạt động đại lý bảo hiểm",
  },
  {
    id: uuidV4(),
    index: "1",
    spendId: 17,
    valueA: 0,
    valueB: 0,
    valueC: 0,
    valueD: 0,
    valueD2: 0,
    valueE: 0,
    valueG: 0,
    valueH: 0,
    valueI: 0,
    title: "Hoạt động bán hàng đa cấp",
  },
  {
    id: uuidV4(),
    index: "1",
    spendId: 18,
    valueA: 0,
    valueB: 0,
    valueC: 0,
    valueD: 0,
    valueD2: 0,
    valueE: 0,
    valueG: 0,
    valueH: 0,
    valueI: 0,
    title: "Hoạt động kinh doanh được trả thu nhập từ nước ngoài",
  },
  {
    id: uuidV4(),
    index: "1",
    spendId: 19,
    valueA: 0,
    valueB: 0,
    valueC: 0,
    valueD: 0,
    valueD2: 0,
    valueE: 0,
    valueG: 0,
    valueH: 0,
    valueI: 0,
    title: "Hoạt động kinh doanh khác",
  },
  {
    id: uuidV4(),
    index: "6",
    spendId: 20,
    valueA: 0,
    valueB: 0,
    valueC: 0,
    valueD: 0,
    valueD2: 0,
    valueE: 0,
    valueG: 0,
    valueH: 0,
    valueI: 0,
    title: "Tổng cộng",
  },
];

function TaxPersonalTable({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type } = values;
    console.log({ id, name, value, type });
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={3} style={{ textAlign: "center", background: "#f4f4f4" }}>
                STT
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tổng doanh thu trong năm
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số thuế phải nộp
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số thuế đã khấu trừ, đã tạm nộp
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số thuế phải nộp thêm
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số thuế nộp thừa
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>GTGT</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>TNCN</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>GTGT</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>TNCN</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>GTGT</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>TNCN</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>GTGT</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>TNCN</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(a)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(b)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(c)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(d)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(đ)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4", whiteSpace: "nowrap" }}>
                (e)=(b)-(d)
              </Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4", whiteSpace: "nowrap" }}>
                (g)=(c)-(đ)
              </Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4", whiteSpace: "nowrap" }}>
                (h)=(d)-(b)
              </Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4", whiteSpace: "nowrap" }}>
                (i)=(đ)-(c)
              </Td>
            </tr>
            {data.map((item) => {
              return (
                <tr key={item.id}>
                  <Td
                    style={{
                      textAlign: "center",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: item.spendId === 20 ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.index}
                  </Td>
                  <Td
                    style={{
                      textAlign: "left",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: item.spendId === 20 ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.title}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: item.spendId === 20 ? "#ddeff3" : "transparent",
                    }}
                  >
                    [{item.spendId}]
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: item.spendId === 20 ? "#ddeff3" : "transparent",
                      paddingRight: 8,
                    }}
                  >
                    {item.spendId === 20 ? (
                      item.valueA
                    ) : (
                      <InputTable
                        value={item.valueA}
                        name="valueA"
                        id={item.id}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: [15, 16, 20]?.includes(item.spendId) ? "#ddeff3" : "transparent",
                      paddingRight: 8,
                    }}
                  >
                    {[15, 16, 20]?.includes(item.spendId) ? (
                      item.valueB
                    ) : (
                      <InputTable
                        value={item.valueB}
                        name="valueB"
                        id={item.id}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: item.spendId === 20 ? "#ddeff3" : "transparent",
                      paddingRight: 8,
                    }}
                  >
                    {item.spendId === 20 ? (
                      item.valueC
                    ) : (
                      <InputTable
                        value={item.valueC}
                        name="valueC"
                        id={item.id}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: item.spendId === 20 ? "#ddeff3" : "transparent",
                      paddingRight: 8,
                    }}
                  >
                    {item.spendId === 20 ? (
                      item.valueD
                    ) : (
                      <InputTable
                        value={item.valueD}
                        name="valueD"
                        id={item.id}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: item.spendId === 20 ? "#ddeff3" : "transparent",
                      paddingRight: 8,
                    }}
                  >
                    {item.spendId === 20 ? (
                      item.valueD2
                    ) : (
                      <InputTable
                        value={item.valueD2}
                        name="valueD2"
                        id={item.id}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: "#ddeff3",
                      paddingRight: 8,
                    }}
                  >
                    {item.valueE}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: "#ddeff3",
                      paddingRight: 8,
                    }}
                  >
                    {item.valueG}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: "#ddeff3",
                      paddingRight: 8,
                    }}
                  >
                    {item.valueH}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      fontWeight: item.spendId === 20 ? 700 : 400,
                      background: "#ddeff3",
                      paddingRight: 8,
                    }}
                  >
                    {item.valueI}
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable);

function InputTable(props) {
  const { id, onChange, type = "text", name, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.2rem 0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
